const ENV = process.env.REACT_APP_ENV;

const API_BASE = ENV === "PROD" ? process.env.REACT_APP_API_BASE_URL_PROD : process.env.REACT_APP_API_BASE_URL_DEV;

export { API_BASE };